import { render } from "./area-filter.vue?vue&type=template&id=20e83b9d&scoped=true&lang=pug"
import script from "./area-filter.vue?vue&type=script&lang=js"
export * from "./area-filter.vue?vue&type=script&lang=js"

import "./area-filter.vue?vue&type=style&index=0&id=20e83b9d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e83b9d"]])

export default __exports__